<header class="topbar">
    <!-- Menu toggle: opens the sidebar drawer on tablet / mobile (hidden on desktop by CSS) -->
    <button type="button" class="hamburger-btn"
            (click)="toggleMobileMenu()"
            aria-label="Toggle navigation menu"
            aria-controls="app-sidebar"
            [attr.aria-expanded]="isMobileMenuOpen$ | async">
      <span class="hamburger-line"></span>
    </button>

    <!-- Left Section -->
    <div class="topbar-left">
      <h2 class="page-title" [title]="currentPage | titlecase">{{ currentPage | titlecase }}</h2>
    </div>

    <!-- Right Section -->
    <div class="topbar-right">
      <!-- Country Selector -->
      <!-- <div class="country-display">
        <img [src]="selectedCountry.flag" [alt]="selectedCountry.name" class="flag-icon"/>
        <span class="country-display">{{ selectedCountry.code }}</span>
      </div> -->
      <div class="country-display" *ngIf="selectedCountry">
        <img [src]="getFlagUrl(selectedCountry.country)" [alt]="selectedCountry.country + ' Flag'" class="flag-icon"
          *ngIf="getFlagUrl(selectedCountry.country)" />
          <p class="country-name" style="color: black;">{{ flagName }}</p>
      </div>

      <!-- Notifications -->
      <button type="button" class="notification-btn" (click)="toggleNotifications()" aria-label="Notifications">
        <!-- <i class="material-icons">notifications</i> -->
         <i class="bi bi-bell bell" aria-hidden="true"></i>
        <span class="notification-badge" *ngIf="notificationCount > 0">
          {{ notificationCount }}
        </span>
      </button>

      <!-- User Profile (hover on desktop, tap on touch) -->
      <div class="user-profile"
           (mouseenter)="openProfileCard()"
           (mouseleave)="closeProfileCard()"
           (keydown.escape)="closeProfileCardNow()">
        <button type="button" class="profile-btn" (click)="toggleProfileMenu()"
                aria-label="User profile menu" aria-haspopup="true"
                [attr.aria-expanded]="showProfileMenu">
          <div class="user-info" *ngIf="user">
            <span class="user-name">{{ profileData?.first_name}} {{  profileData?.last_name }}</span>
            <span class="user-email">{{  profileData?.email }}</span>
          </div>
          <img  *ngIf="profileImg;" [alt]="profileData?.first_name" [src]="profileImg" class="avatar" />
           <div class="avatar-text" *ngIf="!profileImg">
              {{ profileData?.first_name?.charAt(0).toUpperCase() }}
            </div>
          <!-- 👇 Show image if available, otherwise fallback avatar -->
          <!-- <ng-container *ngIf="profileImg; else noImg">
            <img [alt]="profileData?.first_name" [src]="profileImg" class="avatar" />
          </ng-container>

          <ng-template #noImg>
            <div class="avatar-text">
              {{ profileData?.first_name?.charAt(0).toUpperCase() }}
            </div>
          </ng-template> -->

        </button>

        <!-- Profile hover card: avatar + name + email (existing profile data, no extra API call) -->
        <div class="profile-card" *ngIf="showProfileMenu" role="group" aria-label="Profile details">
          <div class="profile-card-avatar">
            <img *ngIf="profileImg; else cardInitial" [src]="profileImg" [alt]="profileData?.first_name" />
            <ng-template #cardInitial>{{ profileData?.first_name?.charAt(0).toUpperCase() }}</ng-template>
          </div>
          <p class="profile-card-name">{{ profileData?.first_name }} {{ profileData?.last_name }}</p>
          <p class="profile-card-email">{{ profileData?.email }}</p>
        </div>
        <!-- <div class="profile-dropdown" *ngIf="showProfileMenu">
          <a href="#"><i class="settings"></i>Settings</a>
          <a href="#"><i class="logout"></i>Logout</a>
        </div> -->
      </div>
    </div>
  </header>